module.exports = __webpack_public_path__ + "static/media/proj3-creekcrossing.2a586e84.jpg";